import React from "react";

import styles from "./styles";

const HeaderRow: React.FunctionComponent<{
    columnHeaders: string[]
}> = (props) => {
    return (<tr style={styles.headerRow}>
        {props.columnHeaders.map((columnHeader, index) => <th key={`${columnHeader}-${index}`} style={styles.columnHeader}>{columnHeader}</th>)}
    </tr>)
}

export default HeaderRow;
